
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, FundLookupViewModel, ILegacyLookupService, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * FundLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class FundLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<FundLookupViewModel[]>> {
        return this.$apiService.sendAuth("IFundLookupService/Lookup", pCriteria);
    }
}
